import { createContext, useContext } from 'react'
import { useSelector } from 'react-redux'
import { WhichWeightAPI } from 'WhichWeightAPI'
import { ModalKey, ModalContext } from 'components/Modals/ModalContext'
import moment from 'moment'

export const OrganizationBillingContext = createContext()

export const OrganizationBillingContextProvider = ({ children }) => {
    const organizationId = useSelector((state) => state.user.organizationId)
    const billingLocalTimestamp = useSelector((state) => state.organization.billingLocalTimestamp)

    const { ShowModal } = useContext(ModalContext)

    const GetBillingDataFromBackend = async (setBillingData) => {
        const jsonBody = {
            organizationId: organizationId,
            localDateString: billingLocalTimestamp.format('YYYY-MM-DD'),
            monthStartString: billingLocalTimestamp.clone().startOf('month').format('YYYY-MM-DD'),
            monthEndString: billingLocalTimestamp.clone().endOf('month').format('YYYY-MM-DD'),
            utcOffsetMinutes: moment().utcOffset() // UTC offset in minutes for timezone-aware date calculations
        }

        // console.log(jsonBody);

        const response = await WhichWeightAPI("BILLING", 'GET', '/coach_billing_preview', jsonBody)

        // console.log(response.data.data);

        if (response.data.status === 'failure') {
            console.error(response);
            return
        }

        setBillingData(response.data.data)
    }

    const ShowOffboardAthleteModal = (athlete) => {
        const modalData = {
            key: ModalKey.AthleteOffboard,
            size: 'quarter',
            athlete: athlete,
        }

        ShowModal(modalData)
    }

    const organizationBillingContextData = {
        GetBillingDataFromBackend,
        ShowOffboardAthleteModal
    }

    return (
        <OrganizationBillingContext.Provider 
            value={organizationBillingContextData}
        >
            {children}
        </OrganizationBillingContext.Provider>
    )
}
